import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import numeral from 'numeral'
import PropTypes from 'prop-types'

import { ColorBoxContent } from '../../../common/ui/colorBox'
import { CheckIcon } from '../../../common/ui/icons'
export default function OnboardReview(props) {
  const {
    children,
    planId,
    plans,
    numberOfSims,
    totalPrice,
    addOnPrice,
    handleCreate,
    unexpectedError,
    goPreviousPage,
    setDialogOpen
  } = props

  return (
    <div>
      <Box width='100%' sx={{ padding: `0px 24px` }}>
        <Typography variant='h4'>Please Review Your Order Details</Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <Box width='60%'>
            <Typography variant='subtitle1' sx={{ marginBottom: 6 }}>
              Ensure that the information entered is correct. Upon confirmation,
              an email will be sent to the provided email address which will
              contain a URL to check the status of the order.
            </Typography>
          </Box>
        </Box>

        <Box display='flex' width='100%'>
          {/* Select Plan Column */}
          <Box sx={{ margin: '24px 0', display: 'flex', width: '100%' }}>
            <ColorBoxContent
              variant='secondary'
              style={{ padding: 0, width: '100%', minHeight: '512px' }}
            >
              <Box
                sx={{
                  padding: `24px 0 16px 24px`
                }}
              >
                <Typography variant='h4' sx={{ margin: '0' }}>
                  Plan Selected
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  backgroundColor: 'primary.main',
                  padding: `4px 24px`
                }}
              >
                <Typography variant='h4' sx={{ color: 'white' }}>
                  {plans[planId].productName}
                </Typography>
                <Typography variant='h4' sx={{ color: 'white' }}>
                  SGD${plans[planId].baseplan.price.value.toFixed(2)}/mth
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: 24
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <Typography>
                    <b>Breakdown</b>
                  </Typography>
                  <Typography>
                    <b>
                      {numberOfSims} x SGD$
                      {plans[planId].baseplan.price.value.toFixed(2)}
                    </b>
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <CheckIcon />
                  <Typography sx={{ margin: '8px' }}>
                    {numeral(plans[planId].baseplan.data * 1000).format('0b')}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <CheckIcon />
                  <Typography sx={{ margin: '8px' }}>
                    {plans[planId].baseplan.voice} min
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <CheckIcon />
                  <Typography sx={{ margin: '8px' }}>
                    {plans[planId].baseplan.sms} SMS
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <CheckIcon />
                  <Typography sx={{ margin: '8px' }}>
                    100% customizable
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: 40
                  }}
                >
                  <Typography>
                    <b>Add-Ons</b>
                  </Typography>
                  <Typography>
                    <b>SGD${addOnPrice.toFixed(2)}</b>
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <CheckIcon />
                  <Typography sx={{ margin: '8px' }}>None</Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: 10
                  }}
                >
                  <Typography>
                    <b>Total Price</b>
                  </Typography>
                  <Typography>
                    <b>SGD${totalPrice.toFixed(2)}/mth</b>
                  </Typography>
                </Box>
              </Box>
              {/* end here */}
            </ColorBoxContent>
          </Box>

          {/* Details Column */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              marginLeft: 4
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '50%',
                justifyContent: 'flex-start'
              }}
            >
              <Typography>
                {children}
                <Typography sx={{ color: `error.main` }}>
                  {unexpectedError}
                </Typography>
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <Button
            variant='secondary'
            sx={{ height: '50px' }}
            onClick={goPreviousPage}
          >
            Edit Details
          </Button>
          <Button
            variant='filled'
            sx={{
              display: 'flex',
              height: '50px'
            }}
            onClick={() => {
              handleCreate()
              setDialogOpen(true)
            }}
          >
            Confirm Order
          </Button>
        </Box>
      </Box>
    </div>
  )
}

OnboardReview.propTypes = {
  children: PropTypes.node,
  planId: PropTypes.number.isRequired,
  plans: PropTypes.array.isRequired,
  numberOfSims: PropTypes.number.isRequired,
  totalPrice: PropTypes.number.isRequired,
  addOnPrice: PropTypes.number.isRequired,
  handleCreate: PropTypes.func,
  unexpectedError: PropTypes.string.isRequired,
  goPreviousPage: PropTypes.func.isRequired,
  setDialogOpen: PropTypes.func.isRequired
}
